function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { Controls, validators } from 'shared/helper/form';
import './ChinaPhoneVerification.scss';
import { T, useTranslate } from 'shared/helper/translate';
import featureEnabled from 'shared/helper/feature';
import OtpTimer from 'researcher/authentication/components/OtpTimer';
var Text = Controls.Text;
var _chinesePhoneRequired = validators.chinesePhoneRequired,
  createChinesePhoneLengthValidator = validators.createChinesePhoneLengthValidator,
  createChinesePhoneNumbersOnlyValidator = validators.createChinesePhoneNumbersOnlyValidator;
var OTP_LENGTH = 6;
var OTP_DURATION = 60;
var phoneMessages = {
  chinesePhoneRequired: 'contact-number-required',
  chinesePhoneLength: 'contact-number-validation',
  chinesePhoneNumbersOnly: 'contact-number-no-letters-validation'
};
function ChinaPhoneVerification(_ref) {
  var _methods$formState$er, _methods$formState$er3;
  var methods = _ref.methods,
    isChinaSelected = _ref.isChinaSelected,
    sendOtp = _ref.sendOtp,
    verifyOtp = _ref.verifyOtp,
    updatePhoneVerification = _ref.updatePhoneVerification,
    setOtpPending = _ref.setOtpPending,
    onPhoneBlur = _ref.onPhoneBlur;
  useTranslate();
  var chinaOtpEnabled = featureEnabled('rubriq_china_Phone_Otp_Enabled');
  var countries = useSelector(function (_ref2) {
    var account = _ref2.account;
    return account.countries;
  });
  var countryCode = methods.watch('countryCode');
  var phoneVerified = methods.watch('phoneVerified');
  var watchedPhone = methods.watch('phoneNumber');
  useEffect(function () {
    if (watchedPhone !== undefined) {
      setIsTypingPhone(true);
      setSubmittedOnce(false);
    }
  }, [watchedPhone]);
  var phoneError = (_methods$formState$er = methods.formState.errors) === null || _methods$formState$er === void 0 ? void 0 : _methods$formState$er.phoneNumber;
  var clearPhoneVerificationGuard = function clearPhoneVerificationGuard() {
    var _methods$formState$er2;
    if ((_methods$formState$er2 = methods.formState.errors) !== null && _methods$formState$er2 !== void 0 && _methods$formState$er2.phoneVerificationGuard) {
      methods.clearErrors('phoneVerificationGuard');
    }
  };
  var originalPhoneRef = useRef(methods.getValues('phoneNumber'));
  useEffect(function () {
    methods.register('phoneVerificationGuard', {
      validate: function validate() {
        if (!isChinaSelected) {
          return true;
        }
        var originalPhone = originalPhoneRef.current;
        var currentPhone = methods.getValues('phoneNumber');
        var verified = methods.getValues('phoneVerified');
        if (originalPhone === currentPhone) {
          return true;
        }
        return verified || 'mobile-number-otp-info';
      }
    });
  }, [methods, isChinaSelected]);
  useEffect(function () {
    methods.trigger('phoneNumber');
  }, [watchedPhone, countryCode]);
  var otpRefs = useRef([]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    otpSent = _useState2[0],
    setOtpSent = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    otpVerified = _useState4[0],
    setOtpVerified = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    otpVerifiedPhone = _useState6[0],
    setOtpVerifiedPhone = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    processing = _useState8[0],
    setProcessing = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    verifyingOtp = _useState10[0],
    setVerifyingOtp = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    cooldownActive = _useState12[0],
    setCooldownActive = _useState12[1];
  var _useState13 = useState(null),
    _useState14 = _slicedToArray(_useState13, 2),
    cooldownEndTime = _useState14[0],
    setCooldownEndTime = _useState14[1];
  var _useState15 = useState(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isTypingPhone = _useState16[0],
    setIsTypingPhone = _useState16[1];
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    submittedOnce = _useState18[0],
    setSubmittedOnce = _useState18[1];
  var isPhoneValid = watchedPhone && !phoneError;
  var isPhoneDisabled = processing || cooldownActive;
  useEffect(function () {
    if (methods.formState.isSubmitted) {
      setIsTypingPhone(false);
      setSubmittedOnce(true);
    }
  }, [methods.formState.isSubmitted]);
  useEffect(function () {
    var verified = methods.getValues('phoneVerified');
    if (verified) {
      setOtpVerified(true);
      setOtpVerifiedPhone(methods.getValues('phoneNumber'));
    }
  }, [methods]);

  // reset if phone changes

  useEffect(function () {
    if (!otpVerified) return;
    if (otpVerifiedPhone !== watchedPhone) {
      setOtpSent(false);
      setOtpVerified(false);
      methods.setValue('otp', '');
      methods.setValue('phoneVerified', false);
      setOtpPending(false);
      setOtpVerifiedPhone(null);
    }
  }, [watchedPhone, otpVerified, otpVerifiedPhone, methods]);

  // cooldown watcher

  useEffect(function () {
    if (!cooldownEndTime) return undefined;
    var interval = setInterval(function () {
      if (Date.now() >= cooldownEndTime) {
        setCooldownActive(false);
        setCooldownEndTime(null);

        // clear OTP but keep boxes visible
        methods.setValue('otp', '');
        otpRefs.current.forEach(function (_, i) {
          if (otpRefs.current[i]) {
            otpRefs.current[i].value = '';
          }
        });
        setTimeout(function () {
          var _otpRefs$current$;
          (_otpRefs$current$ = otpRefs.current[0]) === null || _otpRefs$current$ === void 0 || _otpRefs$current$.focus();
        }, 50);
      }
    }, 500);
    return function () {
      return clearInterval(interval);
    };
  }, [cooldownEndTime]);
  var handleSendOtp = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _methods$getValues;
      var valid, success, end;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsTypingPhone(false);
            methods.clearErrors('phoneVerificationGuard');
            _context.next = 4;
            return methods.trigger('phoneNumber');
          case 4:
            valid = _context.sent;
            if (isChinaSelected) {
              _context.next = 7;
              break;
            }
            return _context.abrupt("return");
          case 7:
            if (!(!chinaOtpEnabled || cooldownActive)) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return");
          case 9:
            setOtpSent(true);
            setOtpPending(true);
            setProcessing(true);
            _context.next = 14;
            return sendOtp({
              phoneNumber: methods.getValues('phoneNumber'),
              countryCode: (_methods$getValues = methods.getValues('countryCode')) === null || _methods$getValues === void 0 ? void 0 : _methods$getValues.value
            });
          case 14:
            success = _context.sent;
            if (success) {
              end = Date.now() + OTP_DURATION * 1000;
              setCooldownEndTime(end);
              setCooldownActive(true);
            }
            setProcessing(false);
          case 17:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function handleSendOtp() {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleVerifyOtp = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var success, phone;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            setVerifyingOtp(true);
            _context2.next = 3;
            return verifyOtp({
              phoneNumber: methods.getValues('phoneNumber'),
              code: methods.getValues('otp')
            });
          case 3:
            success = _context2.sent;
            if (!success) {
              _context2.next = 15;
              break;
            }
            setOtpVerified(true);
            setOtpSent(false);
            phone = methods.getValues('phoneNumber');
            setOtpVerifiedPhone(phone);
            methods.setValue('phoneVerified', true, {
              shouldDirty: true
            });
            originalPhoneRef.current = phone;
            _context2.next = 13;
            return updatePhoneVerification({
              userDetails: {
                phoneNumber: phone,
                phoneVerified: true
              }
            });
          case 13:
            _context2.next = 18;
            break;
          case 15:
            // clear OTP
            methods.setValue('otp', '');

            // clear boxes visually
            otpRefs.current.forEach(function (_, i) {
              if (otpRefs.current[i]) {
                otpRefs.current[i].value = '';
              }
            });

            // focus first box
            setTimeout(function () {
              var _otpRefs$current$2;
              (_otpRefs$current$2 = otpRefs.current[0]) === null || _otpRefs$current$2 === void 0 || _otpRefs$current$2.focus();
            }, 50);
          case 18:
            setOtpPending(false);
            setVerifyingOtp(false);
          case 20:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function handleVerifyOtp() {
      return _ref4.apply(this, arguments);
    };
  }();
  var watchedOtp = methods.watch('otp') || '';
  var handleOtpChange = function handleOtpChange(value, index) {
    if (!/^[0-9]?$/.test(value)) return;
    var otpArray = watchedOtp.padEnd(OTP_LENGTH, '').split('');
    otpArray[index] = value;
    var otp = otpArray.join('');
    methods.setValue('otp', otp);
    if (value && index < OTP_LENGTH - 1) {
      var _otpRefs$current;
      (_otpRefs$current = otpRefs.current[index + 1]) === null || _otpRefs$current === void 0 || _otpRefs$current.focus();
    }
    if (otp.replace(/_/g, '').length === OTP_LENGTH) {
      handleVerifyOtp();
    }
  };
  var phoneOptions = countries.map(function (c) {
    return {
      value: "".concat(c.isoCode, "-").concat(c.countryCode),
      label: "(".concat(c.countryCode, ") ").concat(c.name),
      isoCode: c.isoCode,
      countryCode: c.countryCode
    };
  });
  if (!phoneOptions.length) {
    return null;
  }
  var formatOptionLabel = function formatOptionLabel(country) {
    return /*#__PURE__*/React.createElement("div", {
      className: "country-option-with-flag"
    }, /*#__PURE__*/React.createElement("img", {
      src: "https://flagcdn.com/w20/".concat(country.isoCode.toLowerCase(), ".png"),
      alt: ""
    }), country.label);
  };
  if (!chinaOtpEnabled) {
    return null;
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "rs-china-phone-verification"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rs-phone-input-row"
  }, !phoneVerified ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, {
    className: "rs-country-select",
    classNamePrefix: "rs-select",
    options: phoneOptions,
    isDisabled: isChinaSelected,
    isSearchable: !isChinaSelected,
    value: phoneOptions.find(function (c) {
      return c.isoCode === (countryCode === null || countryCode === void 0 ? void 0 : countryCode.isoCode);
    }) || phoneOptions.find(function (c) {
      return c.isoCode === 'CN';
    }),
    onChange: function onChange(option) {
      methods.setValue('countryCode', {
        value: "+".concat(option.countryCode),
        isoCode: option.isoCode
      }, {
        shouldDirty: true,
        shouldValidate: true
      });
    },
    formatOptionLabel: formatOptionLabel
  }), /*#__PURE__*/React.createElement("div", {
    className: "rs-phone-field"
  }, isTypingPhone && !submittedOnce && phoneError && /*#__PURE__*/React.createElement("em", {
    className: "error"
  }, /*#__PURE__*/React.createElement(T, {
    source: phoneMessages[methods.formState.errors.phoneNumber.type]
  })), /*#__PURE__*/React.createElement(Text, {
    name: "phoneNumber",
    maxLength: (countryCode === null || countryCode === void 0 ? void 0 : countryCode.value) === '+86' ? 11 : undefined,
    placeholder: "PHONE_NUMBER",
    styles: {
      wrapper: 'm-0 p-0',
      label: 'd-none',
      controlsWrapper: 'm-0 p-0',
      controlClass: "rs-phone-input ".concat(isPhoneDisabled ? 'rs-disabled' : '')
    },
    disabled: isPhoneDisabled,
    onBlur: function onBlur() {
      clearPhoneVerificationGuard();
      if (onPhoneBlur) onPhoneBlur.apply(void 0, arguments);
    },
    validators: {
      chinesePhoneRequired: function chinesePhoneRequired() {
        var originalPhone = originalPhoneRef.current;
        var currentPhone = methods.getValues('phoneNumber');
        if (originalPhone === currentPhone) return true;
        return _chinesePhoneRequired(countryCode === null || countryCode === void 0 ? void 0 : countryCode.value)(currentPhone);
      },
      chinesePhoneLength: function chinesePhoneLength() {
        var originalPhone = originalPhoneRef.current;
        var currentPhone = methods.getValues('phoneNumber');
        if (originalPhone === currentPhone) return true;
        return createChinesePhoneLengthValidator(countryCode === null || countryCode === void 0 ? void 0 : countryCode.value)(currentPhone);
      },
      chinesePhoneNumbersOnly: function chinesePhoneNumbersOnly() {
        var originalPhone = originalPhoneRef.current;
        var currentPhone = methods.getValues('phoneNumber');
        if (originalPhone === currentPhone) return true;
        return createChinesePhoneNumbersOnlyValidator(countryCode === null || countryCode === void 0 ? void 0 : countryCode.value)(currentPhone);
      }
    }
  })), isChinaSelected && /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn btn-primary btn-squared rs-verify-btn ".concat(!isPhoneValid ? 'rs-disabled-faded' : ''),
    disabled: !isPhoneValid || processing || cooldownActive,
    onClick: handleSendOtp
  }, cooldownActive ? /*#__PURE__*/React.createElement(OtpTimer, {
    active: true,
    seconds: cooldownEndTime ? Math.max(0, Math.ceil((cooldownEndTime - Date.now()) / 1000)) : OTP_DURATION
  }) : /*#__PURE__*/React.createElement(T, {
    source: "verify"
  }))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "rs-phone-verified-field"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    className: "form-control rs-phone-input",
    value: "".concat((countryCode === null || countryCode === void 0 ? void 0 : countryCode.value) || '+86', " ").concat(watchedPhone),
    readOnly: true
  })), /*#__PURE__*/React.createElement("div", {
    className: "rs-verified-inline"
  }, /*#__PURE__*/React.createElement(T, {
    source: "VERIFIED_BADGE"
  })))), otpSent && /*#__PURE__*/React.createElement("div", {
    className: "rs-otp-container"
  }, [0, 1, 2, 3, 4, 5].map(function (i) {
    return /*#__PURE__*/React.createElement("input", {
      key: i,
      maxLength: 1,
      inputMode: "numeric",
      className: "rs-otp-box form-control ".concat(verifyingOtp ? 'rs-disabled' : ''),
      ref: function ref(el) {
        otpRefs.current[i] = el;
      },
      value: watchedOtp[i] || '',
      disabled: verifyingOtp,
      readOnly: verifyingOtp,
      onChange: function onChange(e) {
        if (verifyingOtp) return;
        handleOtpChange(e.target.value, i);
      },
      onKeyDown: function onKeyDown(e) {
        if (verifyingOtp) return;
        if (e.key === 'Backspace' && !watchedOtp[i]) {
          var _otpRefs$current2;
          (_otpRefs$current2 = otpRefs.current[i - 1]) === null || _otpRefs$current2 === void 0 || _otpRefs$current2.focus();
        }
      },
      onPaste: function onPaste(e) {
        if (verifyingOtp) return;
        var paste = e.clipboardData.getData('text');
        if (!/^\d{6}$/.test(paste)) return;
        methods.setValue('otp', paste);
        handleVerifyOtp();
      }
    });
  })), methods.formState.isSubmitted && ((_methods$formState$er3 = methods.formState.errors) === null || _methods$formState$er3 === void 0 ? void 0 : _methods$formState$er3.phoneVerificationGuard) && /*#__PURE__*/React.createElement("div", {
    className: "text-danger rs-phone-error"
  }, /*#__PURE__*/React.createElement(T, {
    source: methods.formState.errors.phoneVerificationGuard.message
  })));
}
export default ChinaPhoneVerification;